import { useCallback, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { Row } from 'react-table';

import TableComponent from 'app/components/Table/TableComponent';
import { QUERIES, SORT_BY_NAME_TABLE_QUERY } from 'app/components/Table/core/constants';
import { ID } from 'app/components/Table/core/types';
import { LoadingCard } from 'app/components/Table/loading/LoadingCard';
import RootContentPage from 'app/components/layout/RootContentPage';

import { useAuth } from 'app/modules/auth';
import { useSyncQueryToState } from 'app/modules/query-state/hooks';

import { useNavigateWithSendPath } from 'app/helpers/utils';
import { usePolicyInUser } from 'app/hooks/policy';

import { HIDDEN_BUTTON_ADD } from 'app/constants/environments';
import { PATH } from 'app/constants/path';

import { getCustomers } from '../../company-information/core/requests';
import { Customer, initialCustomer } from '../../company-information/core/type';
import { wardsColumns } from './core/columns';
import { deleteWard, downloadTemperature, getWards } from './core/requests';
import { Ward } from './core/type';
import { FormWardTableCard } from './modal/FormWardTableCard';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const WardManagementPage = () => {
  useSyncQueryToState(window.location.pathname, SORT_BY_NAME_TABLE_QUERY);

  const [customer, setCustomer] = useState<Customer>(initialCustomer);
  const navigate = useNavigateWithSendPath();

  const { currentUser, setCurrentUser } = useAuth();
  const permission = usePolicyInUser(currentUser?.policy ?? []);
  const isSystemAdminCurrent = permission.systemAdmin;
  const organization = useOrganizationStore((state) => state.state.organization);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const dataRes = await getCustomers();
    if (dataRes.data) setCustomer(dataRes.data);
  };

  const renderModalForm = (originalData: any) => {
    return <FormWardTableCard ward={originalData} customer={customer} />;
  };
  const onClickBodyTable = (row: Row) => () => {
    const newWard = row.original as Ward;
    if (newWard.id) {
      // navigate(PATH.BEDS.replace(':id', String(newWard.id)));
      navigate(PATH.WARDS_LAYOUT.replace(':id', String(newWard.id)));
    }
  };

  const { mutate: mutateDownloadTemperature, isLoading: isDownloadingTemperature } = useMutation<
    void,
    Error,
    { wardId: ID }
  >({
    mutationKey: ['download-temperature'],
    mutationFn: (params: { wardId: ID }) => downloadTemperature(params),
  });

  const handleDownloadTemperature = useCallback(
    (wardId: ID) => () => mutateDownloadTemperature({ wardId }),
    [mutateDownloadTemperature],
  );

  return (
    <>
      <RootContentPage
        rootBody={{
          padding: 0,
          border: 'none',
        }}
        title="Locations"
      >
        <TableComponent
          getList={getWards}
          nameQuery={QUERIES.WARDS_LIST}
          originColumns={wardsColumns(isSystemAdminCurrent, handleDownloadTemperature)}
          titleModal="Location"
          ModalForm={renderModalForm}
          deleteById={deleteWard}
          placeholderSearch="Search with location name"
          onClickBodyTable={onClickBodyTable}
          nameBtnAdd={!HIDDEN_BUTTON_ADD ? 'Add location' : ''}
          moreQuery={isSystemAdminCurrent ? `&orgId=${organization?.id}` : ''}
          isBorder={false}
          syncParamUrl
          spacing="xxl"
        />
      </RootContentPage>

      {isDownloadingTemperature && <LoadingCard />}
    </>
  );
};

export default WardManagementPage;
